import { parsePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js';

/**
 * Format phone number for WhatsApp API (remove + and ensure proper format)
 * @param {string} phone - Phone number in international format
 * @returns {string} - Formatted phone number for API
 */
export const formatPhoneForAPI = (phone) => {
  if (!phone) return '';
  
  try {
    const phoneNumberObj = parsePhoneNumber(phone);
    if (phoneNumberObj) {
      // Return the number without + sign for WhatsApp API
      return phoneNumberObj.number.replace('+', '');
    }
  } catch (error) {
    console.error('Phone parsing error:', error);
  }
  
  // Fallback: remove + and any non-digits
  return phone.replace(/[^\d]/g, '');
};

/**
 * Validate phone number
 * @param {string} phone - Phone number to validate
 * @returns {boolean} - Whether the phone number is valid
 */
export const validatePhoneNumber = (phone) => {
  if (!phone) return false;
  return isValidPhoneNumber(phone);
};

/**
 * Get country code from phone number
 * @param {string} phone - Phone number in international format
 * @returns {string} - Country code (e.g., 'IN', 'US')
 */
export const getCountryFromPhone = (phone) => {
  try {
    const phoneNumberObj = parsePhoneNumber(phone);
    return phoneNumberObj?.country || 'IN';
  } catch (error) {
    return 'IN';
  }
};

/**
 * Format phone number for display
 * @param {string} phone - Phone number in international format
 * @returns {string} - Formatted phone number for display
 */
export const formatPhoneForDisplay = (phone) => {
  try {
    const phoneNumberObj = parsePhoneNumber(phone);
    return phoneNumberObj?.formatInternational() || phone;
  } catch (error) {
    return phone;
  }
};